module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "alert alert-info alert-dismissable"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91c118fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/Message.vue
// module id = 475
// module chunks = 1